import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class Media {
    uploadMedia = data => {
        const formData = new FormData()
        formData.set('media', data.media)
        const url = `${APIPath.mediaUpload}${
            data.callfrom ? `?callfrom=${data.callfrom}` : ""
        }`
        return BaseService.upload(url, formData, data.header)
    }
}

const MediaService = new Media()
Object.freeze(MediaService)
export { MediaService }
